export class RestoreImageVolumeInput {
    'providerVolumeId';
    'description';
    'tags';
    'volumeEncryptionKeyId';
    'encryptionKeyId';
    'volumeSettings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeEncryptionKeyId",
            "baseName": "volumeEncryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreImageVolumeInput.attributeTypeMap;
    }
    constructor() {
    }
}
